import { Grid } from '@mui/material';
import { FormikProps } from 'formik';
import { H2 } from 'src/components';
import { ListType, UserType } from 'src/types';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectYards } from 'src/redux/yards/selectors';
import { loadYards } from 'src/redux/yards/actions';
import RosterDialogContent from 'src/containers/RosterSplitContainer/components/RosterDialogContent';
import { FormValues } from '../index';

type Props = {
  formikSplitRoster: FormikProps<FormValues>;
  formikEditRoster: FormikProps<any>;
  ownerOptions: UserType[];
  newOwnerOptions: UserType[];
  rosterName: string;
};

const RosterDetailsStep = ({ formikSplitRoster, formikEditRoster, rosterName, ownerOptions, newOwnerOptions }: Props) => {
  const dispatch = useDispatch();
  const gfOptions: ListType[] = ownerOptions.map((lineman) => ({
    key: lineman.uuid || '',
    value: `${lineman.firstName} ${lineman.lastName}`,
  }));

  const newGfOptions: ListType[] = newOwnerOptions?.map((lineman) => ({
    key: lineman.uuid || '',
    value: `${lineman.firstName} ${lineman.lastName}`,
  }));

  const yards = useSelector(selectYards);
  const yardOptions = yards.map((yard) => ({
    key: yard.id,
    value: yard.name,
  }));

  useEffect(() => {
    if (!yards?.length) {
      dispatch(loadYards.init());
    }
  }, []);

  return (
    <Grid container spacing={2} sx={{ p: 5, pb: 10, overflow: 'auto' }}>
      <Grid item sm={6} sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
        <H2>{`Roster "${rosterName}"`}</H2>

        <RosterDialogContent formik={formikEditRoster} yardOptions={yardOptions} gfOptions={gfOptions} />
      </Grid>

      <Grid item sm={6} sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
        <H2>New Roster</H2>

        <RosterDialogContent formik={formikSplitRoster} yardOptions={yardOptions} gfOptions={newGfOptions} />
      </Grid>
    </Grid>
  );
};

export default RosterDetailsStep;
